// @flow

// Constants
import {
  FILTERS_BRANCH,
  FILTER_STATUS,
  FILTER_START_DATE,
  FILTER_END_DATE,
  FILTER_ASSIGN_TO,
  FILTER_SEASON,
} from './../constants'

export default {
  [FILTERS_BRANCH]: {
    [FILTER_STATUS]: '',
    [FILTER_START_DATE]: '',
    [FILTER_END_DATE]: '',
    [FILTER_ASSIGN_TO]: '',
    [FILTER_SEASON]: '',
  },
}
